module.exports = __webpack_public_path__ + "img/paypal.0c596c01.png";